<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">匯款海關報表</div>
      <div>
      </div>
    </div>
    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(0)" :class="{active:store_id == 0}">全部</li>
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div v-loading="loading" :element-loading-text="$t('努力加载中')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
          <div class="mb15">
            <TimeFrameCom :form="form" />
          </div>
          <el-card class="box-card mb15">
            <div slot="header">
              <div class="flex-between">
                <div>
                  <div>
                    <b> 匯出的交易及匯款人的匯款交易 </b>
                  </div>
                  <div><b>Outward Remittance Transactions and lnward Remittance Transactions </b></div>
                </div>
                <div>
                  <el-button type="primary" @click="import_pdf">PDF</el-button>
                </div>
              </div>
            </div>
            <div>
              <el-table :data="orderData" show-summary :summary-method="getSummaries" style="width: 100%">
                <el-table-column prop="title" label="香港海關交易報表">
                  <template slot-scope="scope">
                    <div class="phonecel"></div>
                    <div v-if="scope.row.rownum==1">
                      其他金錢服務經營者
                    </div>
                    <div v-if="scope.row.rownum==2">
                      個別人士
                    </div>
                    <div v-if="scope.row.rownum==3">
                      其他
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="匯出的匯款">
                  <el-table-column prop="sellamount">
                    <template slot="header" slot-scope="scope">
                      款額(港元) <br>Amount in HKD
                    </template>
                    <template slot-scope="scope">
                      <div class="phonecel" style="text-align:left!important;">匯出的匯款 <br> 款額(港元) <br>Amount in HKD</div>
                      {{tomoney(scope.row.sellamount)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="sellcount">
                    <template slot="header" slot-scope="scope">
                      交易宗數 <br>No.of Transactions
                    </template>
                    <template slot-scope="scope">
                      <div class="phonecel" style="text-align:left!important;">匯出的匯款 <br> 交易宗數 <br>No.of Transactions</div>
                      {{scope.row.sellcount}}
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="匯入的匯款">
                  <el-table-column prop="buyamount">
                    <template slot="header" slot-scope="scope">
                      款額(港元) <br>Amount in HKD
                    </template>
                    <template slot-scope="scope">
                      <div class="phonecel" style="text-align:left!important;">匯入的匯款 <br> 款額(港元) <br>Amount in HKD</div>
                      {{tomoney(scope.row.buyamount)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="buycount">
                    <template slot="header" slot-scope="scope">
                      交易宗數 <br>No.of Transactions
                    </template>
                    <template slot-scope="scope">
                      <div class="phonecel" style="text-align:left!important;">匯入的匯款 <br> 交易宗數 <br>No.of Transactions</div>
                      {{scope.row.buycount}}
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
          <el-card class="box-card mb15">
            <div slot="header" class="clearflex">
              <div><b>需執行客戶盡職審查措施的匯款交易宗數</b></div>
              <div><b> Number of Remittance Transactions requiring Customer Due Diligence(CDD) measures </b></div>
            </div>
            <div>
              <el-table border :data="resultData" show-summary :summary-method="getSummaries" :header-cell-style="{background:'#F5F7FA'}" style="width: 100%">
                <el-table-column prop="rownum" label="香港海關交易報表">
                  <template slot-scope="scope">
                    <div class="phonecel"></div>
                    <div v-if="scope.row.rownum==1">
                      其他金錢服務經營者
                    </div>
                    <div v-if="scope.row.rownum==2">
                      個別人士
                    </div>
                    <div v-if="scope.row.rownum==3">
                      其他
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="successcount">
                  <template slot="header" slot-scope="scope">
                    成功交易的宗數 <br>No.of Successful Transactions
                  </template>
                  <template slot-scope="scope">
                    <div class="phonecel" style="text-align:left!important;">成功交易的宗數 <br>No.of Successful Transactions</div>
                    {{scope.row.successcount}}
                  </template>
                </el-table-column>
                <el-table-column prop="rejectcount">
                  <template slot="header" slot-scope="scope">
                    拒絕案數目# <br>No.of Rejected Cases#
                  </template>
                  <template slot-scope="scope">
                    <div class="phonecel" style="text-align:left!important;">拒絕案數目# <br>No.of Rejected Cases#</div>
                    {{scope.row.rejectcount}}
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </el-card>
          <el-card class="box-card mb15">
            <div slot="header" class="clearflex">
              <div><b>曾向香港警務處聯合財富情報組報告的可疑交易報告宗數</b></div>
              <div><b> Number of suspicious transactions reported to the Joint Financial Intelligence Unit of the Hong Kong Police Force </b></div>
            </div>
            <div>
              <el-table border :data="impeachData" show-summary :summary-method="getSummaries" :header-cell-style="{background:'#F5F7FA'}" style="width: 100%">
                <el-table-column prop="rownum" label="香港海關交易報表">
                  <template slot-scope="scope">
                    <div class="phonecel"></div>
                    可疑交易
                  </template>
                </el-table-column>
                <el-table-column prop="count">
                  <template slot="header" slot-scope="scope">
                    報告的可疑交易宗數# <br>No.of suspicious transactions reported#
                  </template>
                  <template slot-scope="scope">
                    <div class="phonecel" style="text-align:left!important;">報告的可疑交易宗數# <br>No.of suspicious transactions reported#</div>
                    {{scope.row.count}}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import TimeFrameCom from "./components/TimeFrame.vue";
export default {
  components: {
    TimeFrameCom,
  },
  props: {
  },
  name: "Business",
  data () {
    return {
      mso_id: 0,
      store_id: 0,
      stores: [],
      transform: '',
      transformnum: 0,
      isInit: true,
      timer: '',
      loading: false,
      form: {
        starttime: '',
        endtime: '',
        type: 'remit',
      },
      orderData: [
        { rownum: 1, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
        { rownum: 2, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
        { rownum: 3, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
      ],
      resultData: [
        { rownum: 1, rejectcount: 0, successcount: 0 },
        { rownum: 2, rejectcount: 0, successcount: 0 },
        { rownum: 3, rejectcount: 0, successcount: 0 },
      ],
      impeachData: [
        { rownum: 1, count: 0 }
      ]
    }
  },
  methods: {
    import_pdf(){
      this.loading = true;
      let data = this.form;
      // console.log(data);
      this.post('/api/customs/cread_pdf', { 
        data 
      }).then(response => {
        if (response.status == 'success') {
          window.open(response.pdf, response.pdf);
        } else {
          this.$notify({
            message: 'Create PDF Error',
            type: 'error',
            duration: 3000,
            offset: 70
          });
        }
        this.loading = false;
      }).catch(error=>{
        console.log(error);
        this.loading = false;
      })
    },
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '總數 Total';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == 'buyamount' || column.property == 'sellamount') {
            sums[index] = this.tomoney(sums[index]);
          } else {
            sums[index] = sums[index];
          }
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    init () {
      this.loading = true;
      let data = this.form;
      this.post('/api/report/customs_remit', { data }).then(response => {
        if (response.status == 'success') {
          this.orderData = response.info.orderData;
          this.resultData = response.info.resultData;
          this.impeachData = response.info.impeachData;
        } else {
          this.orderData = [
            { rownum: 1, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
            { rownum: 2, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
            { rownum: 3, sellcount: 0, sellamount: 0, buycount: 0, buyamount: 0 },
          ];
          this.resultData = [
            { rownum: 1, rejectcount: 0, successcount: 0 },
            { rownum: 2, rejectcount: 0, successcount: 0 },
            { rownum: 3, rejectcount: 0, successcount: 0 },
          ];
          this.impeachData = [
            { rownum: 1, count: 0 },
          ];
        }
        this.isInit = false;
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      })

    },
    getstore () {
      this.post('/api/store/index', {

      }).then((res) => {
        this.stores = res;
      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.init();
      })
    },
    changestore (store_id) {
      this.store_id = store_id;
      this.form.store_id = store_id;
      this.init();
    },
  },
  async created () {
    this.mso_id = this.sessionRead('mso_id');
    this.form.staff_id = this.sessionRead('staff_id');
    this.form.mso_id = this.sessionRead('mso_id');
    this.getstore();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        if (!this.isInit) {
          this.init();
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>